import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { RessourceService } from '../../_services/ressource/ressource.service';
import { Ressource } from '../../_interfaces/ressource';
import { MatIconModule } from '@angular/material/icon';
import { RessourceFileType } from '../../_enums/ressource_type.enum';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConsentEmbedComponent } from '../../_components/consent-embed/consent-embed.component';

@Component({
    selector: 'app-ressources-details',
    imports: [
    MatIconModule,
    ConsentEmbedComponent
],
    templateUrl: './ressources-details.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './ressources-details.component.scss'
})
export class RessourcesDetailsComponent implements OnInit {
  ressource?: Ressource;
  RessourceFileType = RessourceFileType;
  audioFiles: any[] = [];
  pdfFiles: any[] = [];
  youtubeVideos: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ressourceService: RessourceService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.ressourceService.getRessourceById(id).then(ressource => {
        if (ressource) {
          this.ressource = ressource;   
          this.processFiles();
        } else {
          this.router.navigate(['/ressources']);
        }
      });
    }
  }

  private processFiles() {
    if (!this.ressource?.fichiers) return;

    this.ressource.fichiers.forEach(file => {
      switch (file.type) {
        case RessourceFileType.AUDIO:
          this.audioFiles.push(file);
          break;
        case RessourceFileType.PDF:
          this.pdfFiles.push({ ...file, viewUrl: this.getPdfViewUrl(file.url) });
          break;
        case RessourceFileType.YOUTUBE:
          this.youtubeVideos.push({
            ...file,
            embedUrl: this.getYouTubeEmbedUrl(file.url)
          });
          break;
      }
    });
  }

  /**
   * Affiche le PDF directement depuis Firebase Storage (déjà déclaré comme hébergeur des fichiers)
   * plutôt que via le visualiseur Google Docs, qui enverrait chaque document et l'IP du membre à Google.
   */
  private getPdfViewUrl(url: string): SafeResourceUrl | null {
    try {
      const { protocol, hostname } = new URL(url);
      const trusted = protocol === 'https:' && ['firebasestorage.googleapis.com', 'storage.googleapis.com'].includes(hostname);
      return trusted ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
    } catch {
      return null;
    }
  }

  private getYouTubeEmbedUrl(url: string): string {
    const videoId = this.getYouTubeVideoId(url);
    return `https://www.youtube-nocookie.com/embed/${videoId}`;
  }

  private getYouTubeVideoId(url: string): string {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : '';
  }
}
